import classNames from "classnames";
import InputWrapper from "../../../../../components/Input/InputWrapper";

const Select = ({settings = {}}) => {
    return (
        <InputWrapper>
            <span className={classNames({"required": settings.required})}>{settings.title}</span>
            <div className="select"/>
            {settings.description && <p>{settings.description}</p>}
        </InputWrapper>
    )
};

export default Select;